import {Component, Host, OnInit} from '@angular/core';
import {ApiVehiclesService} from '../../../services/api-directory.service';
import {DirectoryItemComponent} from '../directory-item.component';
import {AbstractView} from '../abstract-view.class';

@Component({
    templateUrl: 'vehicles.template.html',
    providers: [ApiVehiclesService]
})

export class VehiclesComponent extends AbstractView implements OnInit {
    title = 'Vehicle';

    constructor(@Host() parent: DirectoryItemComponent,
                public api: ApiVehiclesService) {
        super(parent, api);
    }

    ngOnInit() {
        if(Object.keys(this.parent.directoryService.urlService.queryParams).length < 1)
            this.parent.directoryService.urlService.queryParams = this.parent.directoryService.urlService.getQueryParamsJson();

        const urlTree = this.parent.router.createUrlTree(
            [],
            {queryParams: this.parent.directoryService.urlService.queryParams, skipLocationChange: true});
        this.parent.router.navigateByUrl(urlTree);

        super.ngOnInit();
    }

    updateCarOwner(form) {
        if ( typeof form.value.owner  === 'number' )
             this.update({owner:     form.value.owner});
        else this.update({ownerName: form.value.owner});
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/vehicles/vehicles.component.ts